import { withStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import React from 'react';
import { CompactPicker } from 'react-color';
import { withTranslation } from 'react-i18next';
import { compose } from 'recompose';
import SelectIcon from '../../../components/Common/Icons/SelectIcon';
import withErrorCatcher from '../../../components/Common/withErrorCatcher.js';
import AdminEditContainer from '../AdminEditContainer.js';

const styles = theme => ({

  item: {
    marginTop: 16
  }
})


class CretificationFields extends React.Component {

  state = {
    shwoColor: false
  }

  shwoColor = e => {
    e.stopPropagation();
    e.preventDefault();
    this.setState({ shwoColor: true })
  } 

  onChangeComplete = (color) => {
    this.setState({ shwoColor: false })
    this.props.changeColor(color.hex)
  }

  render() {
    const { classes, handleChange, icon, title, description, color, save,t } = this.props;

    return (
      <AdminEditContainer save={save} title={t('New certification')} subtitle={t('Create New certification')} description='' >

        <Grid container direction='column'>
          <SelectIcon icon={icon} onChange={handleChange('icon')} />
          <TextField
            className={classes.item}
            fullWidth
            value={title}
            label={t("Title")}
            onChange={handleChange("title")} />
          <TextField
            className={classes.item}
            fullWidth
            value={description}
            label={t("Description")}
            onChange={handleChange("description")} />


          <TextField
            onClick={this.shwoColor}
            value={color}
            className={classes.item}
            fullWidth
            label={t("Color")}
          />
          {
            this.state.shwoColor ? <CompactPicker
              onChangeComplete={this.onChangeComplete} /> : null
          }

        </Grid>
      </AdminEditContainer>
    )
  }

}


export default compose(withStyles(styles),	withTranslation('admin'), withErrorCatcher())(CretificationFields);